import React, { Component } from 'react'
import {
  Menu,
  Button,
  Avatar,
  Icon,
} from 'antd'
import Dropzone from 'react-dropzone'
import ColorHash from 'color-hash'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Dropdown from '../utils/blurrableDropdown'
import history from '../utils/history'
import './header.scss'

class Header extends Component {
  handleFileDrop = (files) => {
    const shouldImport = window.confirm('Are you sure you want to import a new theme? Your theme variables will be overwriten.')
    if (shouldImport) {
      files.forEach((file) => {
        const reader = new FileReader()
        reader.addEventListener('loadend', (event) => {
          this.props.onFileImport({
            variables: event.target.result,
            customSass: '',
          })
        })
        reader.readAsText(file)
      })
    }
  }

  handleExportMenuClick = (event) => {
    const {
      onSCSSExport,
      onBootstrapBuildExport,
      onBootstrapBuildMinExport,
      onCustomSassExport,
    } = this.props
    const exportTypes = {
      scss: onSCSSExport,
      build: onBootstrapBuildExport,
      'build.min': onBootstrapBuildMinExport,
      custom_scss: onCustomSassExport,
    }
    exportTypes[event.key]()
  }

  handleMyProjectsClick = () => {
    history.push('/app/projects')
  }

  handleUserMenuClick = (e) => {
    if (e.key === 'log_out') {
      window.location.href = '/api/user/logout'
    }
    if (e.key === 'settings') {
      history.push('/settings')
    }
  }

  render() {
    const {
      user,
      project,
      builderMode,
    } = this.props
    const exportMenu = (
      <Menu onClick={this.handleExportMenuClick}>
        <Menu.Item key="scss">_variables.scss</Menu.Item>
        <Menu.Item key="custom_scss">custom.scss</Menu.Item>
        <Menu.Item key="build">bootstrap.css</Menu.Item>
        <Menu.Item key="build.min">bootstrap.min.css</Menu.Item>
      </Menu>
    )
    const userMenu = (
      <Menu onClick={this.handleUserMenuClick}>
        <Menu.Item key="settings">Settings</Menu.Item>
        <Menu.Item key="log_out">Log out</Menu.Item>
      </Menu>
    )
    const importMenu = (
      <Menu>
        <Menu.Item key="import">
          <Dropzone
            style={{ height: 'auto', border: 'none' }}
            onDrop={this.handleFileDrop}
            multiple={false}
          >
            Import _variables.scss
          </Dropzone>
        </Menu.Item>
      </Menu>
    )
    return (
      <header className="header">
        <div className="header__logo">
          <Link to="/"><img src="/images/logo-with-text.png" height="35" alt="Bootstrap.build logo" /></Link>
        </div>
        {user && (
          <div className="header__item-right">
            <Dropdown overlay={userMenu} trigger={['click']}>
              <div className="header__user">
                <div>
                  <div className="header__user__email">{user.email}</div>
                  <Avatar
                    size="small"
                    style={{ backgroundColor: `rgb(${new ColorHash().rgb(user.email).join(',')})` }}
                  >
                    {user.email.substr(0, 1).toUpperCase()}
                  </Avatar>
                </div>
              </div>
            </Dropdown>
          </div>
        )
        }
        <div className="header__item-left">
          {user
            ? (
              <Button icon="folder" onClick={this.handleMyProjectsClick}>
                My projects
              </Button>
            )
            : (
              <Link to="/login">
                <Button icon="user">
                  Log in
                </Button>
              </Link>
            )
          }
        </div>
        <div className="header__item-left">
          <Link to="/themes">
            <Button icon="star">
              Free themes
            </Button>
          </Link>
        </div>
        {builderMode && <>
          <div className="header__item-left">
            <Dropdown overlay={importMenu} trigger={['click']}>
              <Button>
                Import
              </Button>
            </Dropdown>
          </div>
          <div className="header__item-left">
            <Dropdown overlay={exportMenu} trigger={['click']}>
              <Button type="primary" icon="cloud-download">Export theme</Button>
            </Dropdown>
          </div>
          {project && (
            <div className="header__item-left">
              <div className="header__project-info">
                <div>
                  Working on:
                  {' '}
                  <b>
                    {project.name}
                    {' '}
                  </b>
                </div>
                <div>
                  {project.ownedByCurrentUser ? (
                    <span className="header__project__isPro">
                      <Icon type="lock" />
                      {' '}
                      Private project
                    </span>
                  ) : (
                    <span className="header__project__isFeatured">
                      <Icon type="star" />
                      {' '}
                        Featured free theme
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </>}
      </header>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user.data,
  project: state.project.currentProject.data,
  compiling: state.builder.compiling,
})

const mapDispatchToProps = {

}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header)
